import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";


export const UsersService = {

    getProfiles: () => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/getProfiles`);
    },
    getAccount: (user_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/accounts-assigned`, { params: {user_id} });
    },
    saveUser: (data: {
        username: string,
        email: string,
        complete_name: string,
        profile_id: string,
        account_id: string
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}users/addUser`, data );
    },
    getAllUsers: (data: {
        user_id: number,
        profile: string
    }) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/get-all`, {params: data} );
    },
    editUser: (data: {
        user_id: number,
        username: string,
        email: string,
        complete_name: string,
        profile_id: string,
        account_id: string
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/edit-user`, data);
    },
    deleteUser: (data: {
        user_id: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}users/delete`, data);
    },
    changeStatusUser: (data: {
        user_id: number,
        status: boolean
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/change-status`, data);
    },
    changePasswordUser: (data: {
        user_id: number
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/change-password`, data);
    },
    getSubAccounts: (data: {
        user_id: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}users/getSubAccountsByUser`, data);
    },
    changeSubAccount: (data: {
        user_id: number,
        area: string,
        sub_account_id: number,
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/set-sub-account`, data);
    },
    getCurrentPermissions: (data: {
      account_id: number,
      user_id: number
    }) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/v3.1/setting-supervisor`, { params: data });
    },
    saveUserPermissions: (data: {
        account_id: number,
        user_id: number,
        settings: {
          dashboard: {
            show: boolean,
            show_ticket: boolean,
            actions: boolean,
            download: boolean
          },
          reports: {
            show: boolean,
            actions: boolean,
            download: boolean
          },
          user: {
            show: boolean,
            actions: boolean,
            create: boolean
          },
          sends: {
            show: boolean,
            actions: boolean,
            create: boolean
          },
          followup: {
            show: boolean,
            actions: boolean,
            download: boolean
          },
          configuration: {
            show: boolean,
            actions: boolean,
            create: boolean,
            download: boolean
          },
          channels: {
            show: boolean,
            actions: boolean,
            create: boolean,
            download: boolean
          },
          accounts: {
            show: boolean,
            actions: boolean
          },
          accounts_db: {
            show: boolean,
            create: boolean,
            actions: boolean
          },
          payments: {
            show: boolean,
            actions: boolean
          },
          bots: {
            show: boolean,
            edit: boolean,
            report: boolean,
            intentions: boolean,
            extras: any
          },
          support: {
            show: boolean,
            actions: boolean,
            create: boolean
          }
        }
      }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}users/v3.1/setting-supervisor`, data);
    },
    
    isUsernameAvailable: (data: {
        username: string,
        userId: number
    }) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/valid-name/${data.userId}`, { params: { username: data.username } } );
    },
}